import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'boldTag'
})
export class BoldTagPipe implements PipeTransform {

  constructor(private _sanitizer: DomSanitizer) { }
  transform(value: any): any {
    let outputString = "";
    let newoutputString = [];
    let outputStringLength = "";

    if (value != null) {
      for (let i = 0; i < value.length; i++) {
        if(outputStringLength.length < 40) {
          if(newoutputString.length >= 1) {
            let a = newoutputString[i - 1].length;
            newoutputString.push(value[i].slice(0, (40 - a)));
            outputStringLength = outputStringLength + value[i].slice(0, (40 - a));
          } else {
            newoutputString.push(value[i].slice(0, 40));
            outputStringLength = outputStringLength + value[i].slice(0, 40);
          }
        }
      }

      for (let i = 0; i < newoutputString.length; i++) {
        if (newoutputString[i].includes(':')) {
          let a = newoutputString[i].split(':');
          outputString = outputString + '<strong>' + a[0] + '</strong>' + ': ' + '<i>' + a[1] + '</i>';
        }
        else if (i > 0) { let a = newoutputString[i];
        outputString = outputString + '<strong>' + a + '</strong>' }
        // else if (outputString !== '') {
        //   outputString = outputString + ',' + '<i>' + newoutputString[i] + '</i>';
        // }
        if (newoutputString[i + 1] != undefined) {
          // if (value[i + 1].includes(':')) {
            outputString = outputString + '<span style="color:green;font-weight:bold; margin:0 4px;">||</span>';
          // }
        }
      };

      if (outputStringLength.length >= 40) {
        return this._sanitizer.bypassSecurityTrustHtml(outputString + '...');
      } else {
        return this._sanitizer.bypassSecurityTrustHtml(outputString);
      }
    }
    else {
      return value;
    }
  }
}









// if(value.includes(':')){
    //   a = value.split(':');
    // }
    // else {
    //   a = value;
    // }

    // if (Array.isArray(a)) {
    //   b = '<strong>' + a[0] + '</strong>' + ': ' + '<i>' + a[1] ;
    // } else {
    //   b = ',' + '<strong>' + a + '</strong>'
    // }


    // if (Array.isArray(a)) {
    //   b = '<strong>' + a[0] + '</<strong>' + ': ' + '<i>' + a[1] + '</i>' ;
    // } else {
    //   b = ',' + '<i>' + a + '</i>'
    // }
    //return b;
